export default {
  namespaced: true,
  state: {
    breadcrumbData: []
  },
  getters: {},
  mutations: {
    UPDATE_BREADCRUMB_DATA: (state, res) => {
      let entities = []
      if (res.parents) {
        // parent entities
        entities = res.parents.map((x) => {
          return {
            id: x.id,
            text: x.name || x.label || x.text, // backend and elment-ui tree use different property names
            active: false,
            to: `/vaults/${res.vaultId}/${x.id === res.vaultId ? '0' : x.id}`
          }
        })
      }

      // current entity
      entities = entities.concat({
        id: res.id,
        text: res.name || res.label || res.text,
        active: true,
        to: `/vaults/${res.vaultId}/${res.id === res.vaultId ? '0' : res.id}`
      })

      state.breadcrumbData = entities
    },
    GO_TO_PARENT: (state, res) => {
      const parentIndex = state.breadcrumbData.map((x) => x.id).indexOf(res.folderId === '0' ? res.vaultId : res.folderId)
      state.breadcrumbData.length = parentIndex + 1 // arrray notation is 0 based
    }
  },
  actions: {
    goToParentBreadcrumb({ commit }, params) {
      commit('GO_TO_PARENT', params)
    },
    setBreadcrumb({ commit }, params) {
      commit('UPDATE_BREADCRUMB_DATA', params)
    },
    async refreshBreadcrumb({ commit, state }, params) {
      // let res = {}
      // commit('UPDATE_BREADCRUMB_DATA', res.data)
      // return state.breadcrumbData
    }
  }
}
